import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async criaRevisao(revisaoValores = {}){

        let revisao;

        try{

            //==================================================================//
            //========================== Cria Revisão ==========================//
            //==================================================================//

            revisao = await ERP.postOne(Schema.REVISAO_JOB, revisaoValores);
            if(revisao.status != 200){
                throw revisao;
            }

            console.log(revisao);


        }catch(e){

            console.log(e);
            return revisao;

        }

        return revisao;

    },

}